<template>
  <div>
    <div class="wrapp">
      <div v-if="loading" class="container">
        <div class="row">
          <div class="col-12 text-center mt-5">
            <b-spinner
              type="grow"
              style="color: #4ce595; width: 3rem; height: 3rem;"
              label="Large Spinner"
            ></b-spinner>
          </div>
        </div>
      </div>

      <div v-else-if="displayClosingMessage" class="container">
        <div
          v-if="researchInfo.closingMessageEnabled && closingMessage.html"
          class="row"
        >
          <div class="col-12">
            <div v-if="closingMessage.useLogo" class="row">
              <div class="col-12 mt-3">
                <div class="text-center">
                  <img :src="logo" style="height: 75px; max-width: 100%" />
                </div>
              </div>
            </div>

            <div class="row">
              <div
                class="col-12 mb-4 mt-4 closing-message-area"
                v-html="closingMessage.html"
              />
            </div>
          </div>
        </div>

        <div v-else class="row">
          <div class="col-12 text-center mt-4 closing-message-area">
            <span><i class="far fa-smile"></i></span>

            <h4 class="mt-4">{{ $t('researchPage.title') }}</h4>

            <span> {{ $t('researchPage.firstMsg') }} </span>

            <span> {{ $t('researchPage.secondMsg') }} </span>
          </div>
        </div>

        <div class="row">
          <div class="col-12 text-center">
            <div style="padding-left: 70px; padding-right: 70px; margin: 20px;">
              <b-progress
                variant="secondary"
                :value="timerValue"
                height="4px"
              ></b-progress>
            </div>
          </div>
        </div>
      </div>

      <div v-else-if="error" class="container">
        <div class="row">
          <div class="col-12 text-center mt-4 error-area">
            <span><i class="far fa-frown"></i></span>

            <h4 class="mt-4">Oops...</h4>

            <span>{{ error }}</span>
          </div>
        </div>
      </div>

      <div v-else-if="researchInfo.action.paused" class="container">
        <Unavailable />
      </div>

      <div
        v-else
        class="container"
        :style="{
          minHeight: '100vh',
          backgroundColor:
            researchInfo.action.email.template.scale !== 'colors'
              ? researchInfo.action.email.template.background
              : '#ffffff',
        }"
      >
        <div v-if="researchInfo.useLogo" class="row">
          <div class="col-12 mt-3">
            <div class="text-center">
              <img :src="logo" style="height: 75px; max-width: 100%;" />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12" v-if="step === 1 || viewAll">
            <div
              id="body-email-modal"
              class="mt-3 mb-4"
              v-html="researchInfo.text"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-12" v-if="step === 1 || viewAll">
            <template v-if="researchInfo.action.questionHTML">
              <div class="text-center">
                <div v-html="researchInfo.action.questionHTML"></div>
              </div>
            </template>

            <template v-else>
              <div class="text-center">{{ researchInfo.question }}</div>
            </template>

            <methodology
              :textColor="
                researchInfo.action.email.template.scale !== 'colors'
                  ? researchInfo.action.email.template.backgroundtext
                  : '#000000'
              "
              :surveySelectedColor="
                researchInfo.action.email.template.templatebuttonselected
              "
              :surveyTextColor="researchInfo.action.email.template.grade"
              :surveyBorderColor="researchInfo.action.email.template.border"
              :surveyColor="researchInfo.scale"
              :actionMetric="researchInfo.metric"
              :isLinkQrCode="true"
              class="mt-4 mb-3"
            />

            <div class="row" v-if="!viewAll">
              <div class="col-12 text-center">
                <button
                  class="btn btn-primary px-5 py-2"
                  @click="
                    researchInfo.additionalQuestions.length > 0
                      ? (step = 2)
                      : submit
                  "
                >
                  {{
                    researchInfo.additionalQuestions.length > 0
                      ? 'Próximo'
                      : 'Finalizar'
                  }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="
            (step === 3 || viewAll) && researchInfo.commentPosition === 'up'
          "
          class="row mb-4"
        >
          <div class="col-12">
            <div class="feedback-area mt-4">
              <research-replys
                :style="{
                  color:
                    researchInfo.action.email.template.scale !== 'colors'
                      ? researchInfo.action.email.template.backgroundtext
                      : '#000000',
                }"
                :metric="researchInfo.metric"
                :promotersReply="promotersQuestion"
                :neutralReply="neutralQuestion"
                :detractorsReply="detractorsQuestion"
                :grade="testNpsReview"
              />

              <span v-if="displayRequiredFields" class="required mt-2">
                *Obrigatório
              </span>

              <textarea
                v-model="feedback"
                name=""
                id="feedback"
                class="form-control"
                rows="4"
              ></textarea>
            </div>
          </div>

          <div class="col-12 text-center mt-3" v-if="!viewAll">
            <button @click="step = 2" class="btn px-5 py-2">
              <i class="fas fa-arrow-left" />
              Voltar
            </button>

            <button class="btn btn-primary px-5 py-2" @click="submit">
              Finalizar
            </button>
          </div>
        </div>

        <div class="row mt-2" v-if="!viewAll">
          <div
            class="col-12 addquestions-area"
            v-if="researchInfo.additionalQuestions.length > 0 && step === 2"
          >
            <hr v-if="researchInfo.additionalQuestions.length > 0" />

            <div v-if="!isGrouped">
              <div
                v-if="
                  indicatorValuedQuestion(
                    researchInfo.additionalQuestions[position],
                  )
                "
              >
                <template
                  v-if="
                    researchInfo.additionalQuestions[position].profileEnabled
                  "
                >
                <template
                    v-if="
                      researchInfo.additionalQuestions[
                        position
                      ].selectedProfile.includes(conditionalQuestion())
                    "
                  >
                    <template
                      v-if="
                        promotersGrades.includes(testNpsReview) ||
                        detractorsGrades.includes(testNpsReview) ||
                        passivesGrades.includes(testNpsReview)
                      "
                    >
                      <!-- all mandatory questions -->

                      <span
                        v-if="
                          displayRequiredFields &&
                          researchInfo.additionalQuestions[position].type !==
                            'LABEL'
                        "
                        class="required"
                      >
                        *Obrigatório
                      </span>

                      <!-- -->

                      <!-- specific mandatory questions -->

                      <div
                        v-show="
                          showMessage &&
                          researchInfo.additionalQuestions[position]
                            .mandatory &&
                          researchInfo.additionalQuestions[position].type !==
                            'LABEL' &&
                          researchInfo.additionalQuestions[position]
                            .addQuestionAnswer &&
                          researchInfo.additionalQuestions[position]
                            .addQuestionAnswer.review === null
                        "
                      >
                        <span class="required"> *Obrigatório </span>
                      </div>

                      <div
                        v-show="
                          showMessage &&
                          researchInfo.additionalQuestions[position]
                            .mandatory &&
                          researchInfo.additionalQuestions[position].type ===
                            'MULTIPLE' &&
                          researchInfo.additionalQuestions[position]
                            .addQuestionAnswerMultiple.multipleValues &&
                          researchInfo.additionalQuestions[position]
                            .addQuestionAnswerMultiple.multipleValues.length ===
                            0
                        "
                      >
                        <span class="required"> *Obrigatório </span>
                      </div>

                      <div
                        v-show="
                          (showMessage &&
                            researchInfo.additionalQuestions[position]
                              .mandatory &&
                            researchInfo.additionalQuestions[position].type ===
                              'INPUT' &&
                            !researchInfo.additionalQuestions[position]
                              .answerText) ||
                          (researchInfo.additionalQuestions[position]
                            .answerText &&
                            researchInfo.additionalQuestions[position]
                              .answerText.review === null)
                        "
                      >
                        <span class="required"> *Obrigatório </span>
                      </div>

                      <!-- -->

                      <likert
                        v-if="
                          researchInfo.additionalQuestions[position].type ===
                          'LIKERT'
                        "
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :text="researchInfo.additionalQuestions[position].text"
                        :item-id="position.toString()"
                        :index="position"
                        :colorTemplate="researchInfo.scale"
                        :commentEnabled="
                          researchInfo.additionalQuestions[position]
                            .commentEnabled
                        "
                        v-model="
                          researchInfo.additionalQuestions[position]
                            .addQuestionAnswer
                        "
                        :applicableEnabled="
                          researchInfo.additionalQuestions[position]
                            .applicableEnabled
                        "
                        :reviewAnswer="testNpsReview ? testNpsReview : -99"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        @input="getReview"
                      />

                      <c-sat
                        v-if="
                          researchInfo.additionalQuestions[position].type ===
                          'CSAT'
                        "
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :text="researchInfo.additionalQuestions[position].text"
                        :item-id="position.toString()"
                        :index="position"
                        :colorTemplate="researchInfo.scale"
                        v-model="
                          researchInfo.additionalQuestions[position]
                            .addQuestionAnswer
                        "
                        :commentEnabled="
                          researchInfo.additionalQuestions[position]
                            .commentEnabled
                        "
                        :applicableEnabled="
                          researchInfo.additionalQuestions[position]
                            .applicableEnabled
                        "
                        :reviewAnswer="testNpsReview ? testNpsReview : -99"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        @input="getReview"
                      />

                      <star-rating
                        v-if="
                          researchInfo.additionalQuestions[position].type ===
                          'REVIEWS'
                        "
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :text="researchInfo.additionalQuestions[position].text"
                        :item-id="position.toString()"
                        :index="position"
                        v-model="
                          researchInfo.additionalQuestions[position]
                            .addQuestionAnswer
                        "
                        :commentEnabled="
                          researchInfo.additionalQuestions[position]
                            .commentEnabled
                        "
                        :applicableEnabled="
                          researchInfo.additionalQuestions[position]
                            .applicableEnabled
                        "
                        :reviewAnswer="testNpsReview ? testNpsReview : -99"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        @input="getReview"
                      />

                      <like-dislike
                        v-if="
                          researchInfo.additionalQuestions[position].type ===
                          'LIKE/DISLIKE'
                        "
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :questionText="
                          researchInfo.additionalQuestions[position].text
                        "
                        :index="position"
                        v-model="
                          researchInfo.additionalQuestions[position]
                            .addQuestionAnswer
                        "
                        :commentEnabled="
                          researchInfo.additionalQuestions[position]
                            .commentEnabled
                        "
                        :applicableEnabled="
                          researchInfo.additionalQuestions[position]
                            .applicableEnabled
                        "
                        :reviewAnswer="testNpsReview ? testNpsReview : -99"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        @input="getReview"
                      />

                      <emotion
                        v-if="
                          researchInfo.additionalQuestions[position].type ===
                          'EMOTION'
                        "
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :questionText="
                          researchInfo.additionalQuestions[position].text
                        "
                        :index="position"
                        v-model="
                          researchInfo.additionalQuestions[position]
                            .addQuestionAnswer
                        "
                        :commentEnabled="
                          researchInfo.additionalQuestions[position]
                            .commentEnabled
                        "
                        :applicableEnabled="
                          researchInfo.additionalQuestions[position]
                            .applicableEnabled
                        "
                        :reviewAnswer="testNpsReview ? testNpsReview : -99"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        @input="getReview"
                      />

                      <multiple-choices
                        :item-id="position.toString()"
                        v-if="
                          researchInfo.additionalQuestions[position].type ===
                          'MULTIPLE'
                        "
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :type="
                          researchInfo.additionalQuestions[position]
                            .multipleType
                        "
                        :questionText="
                          researchInfo.additionalQuestions[position].text
                        "
                        :choices="
                          researchInfo.additionalQuestions[position].choices
                        "
                        :index="position"
                        v-model="
                          researchInfo.additionalQuestions[position]
                            .addQuestionAnswerMultiple
                        "
                        :commentEnabled="
                          researchInfo.additionalQuestions[position]
                            .commentEnabled
                        "
                        :applicableEnabled="
                          researchInfo.additionalQuestions[position]
                            .applicableEnabled
                        "
                        :reviewAnswer="testNpsReview ? testNpsReview : -99"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        @input="getReview"
                      />

                      <label-question
                        v-if="
                          researchInfo.additionalQuestions[position].type ===
                          'LABEL'
                        "
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :text="researchInfo.additionalQuestions[position].text"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                      />

                      <ces
                        v-if="
                          researchInfo.additionalQuestions[position].type ===
                          'CES'
                        "
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :text="researchInfo.additionalQuestions[position].text"
                        :item-id="position.toString()"
                        :index="position"
                        :colorTemplate="researchInfo.scale"
                        v-model="
                          researchInfo.additionalQuestions[position]
                            .addQuestionAnswer
                        "
                        :commentEnabled="
                          researchInfo.additionalQuestions[position]
                            .commentEnabled
                        "
                        :applicableEnabled="
                          researchInfo.additionalQuestions[position]
                            .applicableEnabled
                        "
                        :reviewAnswer="testNpsReview ? testNpsReview : -99"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        @input="getReview"
                      />

                      <input-type
                        v-if="
                          researchInfo.additionalQuestions[position].type ===
                          'INPUT'
                        "
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :text="researchInfo.additionalQuestions[position].text"
                        :item-id="position.toString()"
                        :index="position"
                        v-model="
                          researchInfo.additionalQuestions[position].answerText
                        "
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        @input="getReview"
                        :isMandatoryForQuestion="researchInfo.mandatory"
                      />

                      <nps
                        v-if="
                          researchInfo.additionalQuestions[position].type ===
                          'NPS'
                        "
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :text="researchInfo.additionalQuestions[position].text"
                        :item-id="position.toString()"
                        :index="position"
                        :colorTemplate="researchInfo.scale"
                        v-model="
                          researchInfo.additionalQuestions[position]
                            .addQuestionAnswer
                        "
                        :commentEnabled="
                          researchInfo.additionalQuestions[position]
                            .commentEnabled
                        "
                        :applicableEnabled="
                          researchInfo.additionalQuestions[position]
                            .applicableEnabled
                        "
                        :reviewAnswer="testNpsReview ? testNpsReview : -99"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        @input="getReview"
                      />

                      <likertEmotion
                        v-if="
                          researchInfo.additionalQuestions[position].type ===
                          'LIKERT/EMOTION'
                        "
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :text="researchInfo.additionalQuestions[position].text"
                        :item-id="position.toString()"
                        :index="position"
                        :colorTemplate="researchInfo.scale"
                        v-model="
                          researchInfo.additionalQuestions[position]
                            .addQuestionAnswer
                        "
                        :commentEnabled="
                          researchInfo.additionalQuestions[position]
                            .commentEnabled
                        "
                        :applicableEnabled="
                          researchInfo.additionalQuestions[position]
                            .applicableEnabled
                        "
                        :reviewAnswer="testNpsReview ? testNpsReview : -99"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        @input="getReview"
                      />
                    </template>
                  </template>
                </template>

                <template v-else>
                  <!-- all mandatory questions -->

                  <span
                    v-if="
                      displayRequiredFields &&
                      researchInfo.additionalQuestions[position].type !==
                        'LABEL'
                    "
                    class="required"
                  >
                    *Obrigatório
                  </span>

                  <!-- -->

                  <!-- specific mandatory questions -->

                  <div
                    v-show="
                      showMessage &&
                      researchInfo.additionalQuestions[position].mandatory &&
                      researchInfo.additionalQuestions[position].type !==
                        'LABEL' &&
                      researchInfo.additionalQuestions[position]
                        .addQuestionAnswer &&
                      researchInfo.additionalQuestions[position]
                        .addQuestionAnswer.review === null
                    "
                  >
                    <span class="required"> *Obrigatório </span>
                  </div>

                  <div
                    v-show="
                      showMessage &&
                      researchInfo.additionalQuestions[position].mandatory &&
                      researchInfo.additionalQuestions[position].type ===
                        'MULTIPLE' &&
                      researchInfo.additionalQuestions[position]
                        .addQuestionAnswerMultiple.multipleValues &&
                      researchInfo.additionalQuestions[position]
                        .addQuestionAnswerMultiple.multipleValues.length === 0
                    "
                  >
                    <span class="required"> *Obrigatório </span>
                  </div>

                  <div
                    v-show="
                      (showMessage &&
                        researchInfo.additionalQuestions[position].mandatory &&
                        researchInfo.additionalQuestions[position].type ===
                          'INPUT' &&
                        !researchInfo.additionalQuestions[position]
                          .answerText) ||
                      (researchInfo.additionalQuestions[position].answerText &&
                        researchInfo.additionalQuestions[position].answerText
                          .review === null)
                    "
                  >
                    <span class="required"> *Obrigatório </span>
                  </div>

                  <!-- -->
                <div v-for="(item, i) in researchInfo.additionalQuestions" :key="i">
                  <likert
                    v-if="
                    item.id === researchInfo.additionalQuestions[position].id &&
                      researchInfo.additionalQuestions[position].type ===
                        'LIKERT' &&
                      !researchInfo.additionalQuestions[position].show
                    "
                    :textColor="
                      researchInfo.action.email.template.scale !== 'colors'
                        ? researchInfo.action.email.template.backgroundtext
                        : '#000000'
                    "
                    :text="researchInfo.additionalQuestions[position].text"
                    :item-id="position.toString()"
                    :index="position"
                    :colorTemplate="researchInfo.scale"
                    v-model="
                      researchInfo.additionalQuestions[position]
                        .addQuestionAnswer
                    "
                    :commentEnabled="
                      researchInfo.additionalQuestions[position].commentEnabled
                    "
                    :applicableEnabled="
                      researchInfo.additionalQuestions[position]
                        .applicableEnabled
                    "
                    :reviewAnswer="testNpsReview ? testNpsReview : -99"
                    :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    :idQuestion="researchInfo.additionalQuestions[position].id"
                    @input="getReview"
                  />

                  <c-sat
                    v-if="
                    item.id === researchInfo.additionalQuestions[position].id &&
                      researchInfo.additionalQuestions[position].type ===
                        'CSAT' &&
                      !researchInfo.additionalQuestions[position].show
                    "
                    :textColor="
                      researchInfo.action.email.template.scale !== 'colors'
                        ? researchInfo.action.email.template.backgroundtext
                        : '#000000'
                    "
                    :text="researchInfo.additionalQuestions[position].text"
                    :item-id="position.toString()"
                    :index="position"
                    :colorTemplate="researchInfo.scale"
                    v-model="
                      researchInfo.additionalQuestions[position]
                        .addQuestionAnswer
                    "
                    :commentEnabled="
                      researchInfo.additionalQuestions[position].commentEnabled
                    "
                    :applicableEnabled="
                      researchInfo.additionalQuestions[position]
                        .applicableEnabled
                    "
                    :reviewAnswer="testNpsReview ? testNpsReview : -99"
                    :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    :idQuestion="researchInfo.additionalQuestions[position].id"
                    @input="getReview"
                  />

                  <star-rating
                    v-if="
                    item.id === researchInfo.additionalQuestions[position].id &&
                      researchInfo.additionalQuestions[position].type ===
                        'REVIEWS' &&
                      !researchInfo.additionalQuestions[position].show
                    "
                    :textColor="
                      researchInfo.action.email.template.scale !== 'colors'
                        ? researchInfo.action.email.template.backgroundtext
                        : '#000000'
                    "
                    :text="researchInfo.additionalQuestions[position].text"
                    :item-id="position.toString()"
                    :index="position"
                    v-model="
                      researchInfo.additionalQuestions[position]
                        .addQuestionAnswer
                    "
                    :commentEnabled="
                      researchInfo.additionalQuestions[position].commentEnabled
                    "
                    :applicableEnabled="
                      researchInfo.additionalQuestions[position]
                        .applicableEnabled
                    "
                    :reviewAnswer="testNpsReview ? testNpsReview : -99"
                    :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    :idQuestion="researchInfo.additionalQuestions[position].id"
                    @input="getReview"
                  />

                  <like-dislike
                    v-if="
                    item.id === researchInfo.additionalQuestions[position].id &&
                      researchInfo.additionalQuestions[position].type ===
                        'LIKE/DISLIKE' &&
                      !researchInfo.additionalQuestions[position].show
                    "
                    :textColor="
                      researchInfo.action.email.template.scale !== 'colors'
                        ? researchInfo.action.email.template.backgroundtext
                        : '#000000'
                    "
                    :questionText="
                      researchInfo.additionalQuestions[position].text
                    "
                    :index="position"
                    v-model="
                      researchInfo.additionalQuestions[position]
                        .addQuestionAnswer
                    "
                    :item-id="position.toString()"
                    :commentEnabled="
                      researchInfo.additionalQuestions[position].commentEnabled
                    "
                    :applicableEnabled="
                      researchInfo.additionalQuestions[position]
                        .applicableEnabled
                    "
                    :reviewAnswer="testNpsReview ? testNpsReview : -99"
                    :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    :idQuestion="researchInfo.additionalQuestions[position].id"
                    @input="getReview"
                  />

                  <emotion
                    v-if="
                    item.id === researchInfo.additionalQuestions[position].id &&
                      researchInfo.additionalQuestions[position].type ===
                        'EMOTION' &&
                      !researchInfo.additionalQuestions[position].show
                    "
                    :textColor="
                      researchInfo.action.email.template.scale !== 'colors'
                        ? researchInfo.action.email.template.backgroundtext
                        : '#000000'
                    "
                    :questionText="
                      researchInfo.additionalQuestions[position].text
                    "
                    :index="position"
                    v-model="
                      researchInfo.additionalQuestions[position]
                        .addQuestionAnswer
                    "
                    :item-id="position.toString()"
                    :commentEnabled="
                      researchInfo.additionalQuestions[position].commentEnabled
                    "
                    :applicableEnabled="
                      researchInfo.additionalQuestions[position]
                        .applicableEnabled
                    "
                    :reviewAnswer="testNpsReview ? testNpsReview : -99"
                    :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    :idQuestion="researchInfo.additionalQuestions[position].id"
                    @input="getReview"
                  />

                  <multiple-choices
                    v-if="
                    item.id === researchInfo.additionalQuestions[position].id &&
                      researchInfo.additionalQuestions[position].type ===
                        'MULTIPLE' &&
                      !researchInfo.additionalQuestions[position].show
                    "
                    :textColor="
                      researchInfo.action.email.template.scale !== 'colors'
                        ? researchInfo.action.email.template.backgroundtext
                        : '#000000'
                    "
                    :type="
                      researchInfo.additionalQuestions[position].multipleType
                    "
                    :questionText="
                      researchInfo.additionalQuestions[position].text
                    "
                    :choices="
                      researchInfo.additionalQuestions[position].choices
                    "
                    :index="position"
                    v-model="
                      researchInfo.additionalQuestions[position]
                        .addQuestionAnswerMultiple
                    "
                    :commentEnabled="
                      researchInfo.additionalQuestions[position].commentEnabled
                    "
                    :applicableEnabled="
                      researchInfo.additionalQuestions[position]
                        .applicableEnabled
                    "
                    :reviewAnswer="testNpsReview ? testNpsReview : -99"
                    :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    :item-id="position.toString()"
                    :idQuestion="researchInfo.additionalQuestions[position].id"
                    @input="getReview"
                  />

                  <ces
                    v-if="
                    item.id === researchInfo.additionalQuestions[position].id &&
                      researchInfo.additionalQuestions[position].type ===
                        'CES' &&
                      !researchInfo.additionalQuestions[position].show
                    "
                    :textColor="
                      researchInfo.action.email.template.scale !== 'colors'
                        ? researchInfo.action.email.template.backgroundtext
                        : '#000000'
                    "
                    :text="researchInfo.additionalQuestions[position].text"
                    :item-id="position.toString()"
                    :index="position"
                    :colorTemplate="researchInfo.scale"
                    v-model="
                      researchInfo.additionalQuestions[position]
                        .addQuestionAnswer
                    "
                    :commentEnabled="
                      researchInfo.additionalQuestions[position].commentEnabled
                    "
                    :applicableEnabled="
                      researchInfo.additionalQuestions[position]
                        .applicableEnabled
                    "
                    :reviewAnswer="testNpsReview ? testNpsReview : -99"
                    :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    :idQuestion="researchInfo.additionalQuestions[position].id"
                    @input="getReview"
                  />

                  <input-type
                    v-if="
                    item.id === researchInfo.additionalQuestions[position].id &&
                      researchInfo.additionalQuestions[position].type ===
                        'INPUT' &&
                      !researchInfo.additionalQuestions[position].show
                    "
                    :textColor="
                      researchInfo.action.email.template.scale !== 'colors'
                        ? researchInfo.action.email.template.backgroundtext
                        : '#000000'
                    "
                    :text="researchInfo.additionalQuestions[position].text"
                    :item-id="position.toString()"
                    :index="position"
                    v-model="
                      researchInfo.additionalQuestions[position].answerText
                    "
                    :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    :idQuestion="researchInfo.additionalQuestions[position].id"
                    @input="getReview"
                    :isMandatoryForQuestion="researchInfo.mandatory"
                  />

                  <label-question
                    v-if="
                    item.id === researchInfo.additionalQuestions[position].id &&
                      researchInfo.additionalQuestions[position].type ===
                        'LABEL' &&
                      !researchInfo.additionalQuestions[position].show
                    "
                    :textColor="
                      researchInfo.action.email.template.scale !== 'colors'
                        ? researchInfo.action.email.template.backgroundtext
                        : '#000000'
                    "
                    :text="researchInfo.additionalQuestions[position].text"
                    :item-id="position.toString()"
                    :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    :idQuestion="researchInfo.additionalQuestions[position].id"
                  />

                  <nps
                    v-if="
                    item.id === researchInfo.additionalQuestions[position].id &&
                      researchInfo.additionalQuestions[position].type ===
                        'NPS' &&
                      !researchInfo.additionalQuestions[position].show
                    "
                    :textColor="
                      researchInfo.action.email.template.scale !== 'colors'
                        ? researchInfo.action.email.template.backgroundtext
                        : '#000000'
                    "
                    :text="researchInfo.additionalQuestions[position].text"
                    :item-id="position.toString()"
                    :index="position"
                    :colorTemplate="researchInfo.scale"
                    v-model="
                      researchInfo.additionalQuestions[position]
                        .addQuestionAnswer
                    "
                    :commentEnabled="
                      researchInfo.additionalQuestions[position].commentEnabled
                    "
                    :applicableEnabled="
                      researchInfo.additionalQuestions[position]
                        .applicableEnabled
                    "
                    :reviewAnswer="testNpsReview ? testNpsReview : -99"
                    :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    :idQuestion="researchInfo.additionalQuestions[position].id"
                    @input="getReview"
                  />

                  <likertEmotion
                    v-if="
                    item.id === researchInfo.additionalQuestions[position].id &&
                      researchInfo.additionalQuestions[position].type ===
                        'LIKERT/EMOTION' &&
                      !researchInfo.additionalQuestions[position].show
                    "
                    :textColor="
                      researchInfo.action.email.template.scale !== 'colors'
                        ? researchInfo.action.email.template.backgroundtext
                        : '#000000'
                    "
                    :text="researchInfo.additionalQuestions[position].text"
                    :item-id="position.toString()"
                    :index="position"
                    :colorTemplate="researchInfo.scale"
                    v-model="
                      researchInfo.additionalQuestions[position]
                        .addQuestionAnswer
                    "
                    :commentEnabled="
                      researchInfo.additionalQuestions[position].commentEnabled
                    "
                    :applicableEnabled="
                      researchInfo.additionalQuestions[position]
                        .applicableEnabled
                    "
                    :reviewAnswer="testNpsReview ? testNpsReview : -99"
                    :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    :idQuestion="researchInfo.additionalQuestions[position].id"
                    @input="getReview"
                  />

                  <template
                    v-if="
                      action.email.additionalQuestions[position].displayType ===
                        'formSearch' &&
                      !researchInfo.additionalQuestions[position].show
                    "
                  >
                    <contact
                      v-if="
                      item.id === researchInfo.additionalQuestions[position].id &&
                        researchInfo.additionalQuestions[position].type ===
                        'CONTACT'
                      "
                      :textColor="
                        researchInfo.action.email.template.backgroundtext
                      "
                      :type="
                        researchInfo.additionalQuestions[position].multipleType
                      "
                      :questionText="
                        researchInfo.additionalQuestions[position].text
                      "
                      :choices="
                        researchInfo.additionalQuestions[position].choices
                      "
                      :index="position"
                      v-model="dataContact"
                      :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    />
                  </template>
                  </div>
                </template>
              </div>
            </div>

            <div v-if="isGrouped">
              <div v-for="(item, i) of pages[position].items" :key="i">
                <div v-if="indicatorValuedQuestion(item)">
                  <template v-if="item.profileEnabled">
                    <template
                      v-if="
                        item.selectedProfile.includes(conditionalQuestion())
                      "
                    >
                      <template
                        v-if="
                          promotersGrades.includes(testNpsReview) ||
                          detractorsGrades.includes(testNpsReview) ||
                          passivesGrades.includes(testNpsReview)
                        "
                      >
                        <!-- all mandatory questions -->

                        <span
                          v-if="displayRequiredFields && item.type !== 'LABEL'"
                          class="required"
                        >
                          *Obrigatório
                        </span>

                        <!-- -->

                        <!-- specific mandatory questions -->

                        <div
                          v-show="
                            showMessage &&
                            item.mandatory &&
                            item.type !== 'LABEL' &&
                            item.addQuestionAnswer &&
                            item.addQuestionAnswer.review === null
                          "
                        >
                          <span class="required"> *Obrigatório </span>
                        </div>

                        <div
                          v-show="
                            showMessage &&
                            item.mandatory &&
                            item.type === 'MULTIPLE' &&
                            item.addQuestionAnswerMultiple.multipleValues &&
                            item.addQuestionAnswerMultiple.multipleValues
                              .length === 0
                          "
                        >
                          <span class="required"> *Obrigatório </span>
                        </div>

                        <div
                          v-show="
                            (showMessage &&
                              item.mandatory &&
                              item.type === 'INPUT' &&
                              !item.answerText) ||
                            (item.answerText && item.answerText.review === null)
                          "
                        >
                          <span class="required"> *Obrigatório </span>
                        </div>

                        <!-- -->

                        <likert
                          v-if="item.type === 'LIKERT'"
                          :textColor="
                            researchInfo.action.email.template.scale !==
                            'colors'
                              ? researchInfo.action.email.template
                                  .backgroundtext
                              : '#000000'
                          "
                          :text="item.text"
                          :item-id="i.toString()"
                          :index="positiion"
                          :colorTemplate="researchInfo.scale"
                          :commentEnabled="item.commentEnabled"
                          v-model="item.addQuestionAnswer"
                          :applicableEnabled="item.applicableEnabled"
                          :reviewAnswer="testNpsReview ? testNpsReview : -99"
                          :addQuestionTemplate="
                            researchInfo.addQuestionTemplate
                          "
                          @input="getReview"
                        />

                        <c-sat
                          v-if="item.type === 'CSAT'"
                          :textColor="
                            researchInfo.action.email.template.scale !==
                            'colors'
                              ? researchInfo.action.email.template
                                  .backgroundtext
                              : '#000000'
                          "
                          :text="item.text"
                          :item-id="i.toString()"
                          :index="i"
                          :colorTemplate="researchInfo.scale"
                          v-model="item.addQuestionAnswer"
                          :commentEnabled="item.commentEnabled"
                          :applicableEnabled="item.applicableEnabled"
                          :reviewAnswer="testNpsReview ? testNpsReview : -99"
                          :addQuestionTemplate="
                            researchInfo.addQuestionTemplate
                          "
                          @input="getReview"
                        />

                        <star-rating
                          v-if="item.type === 'REVIEWS'"
                          :textColor="
                            researchInfo.action.email.template.scale !==
                            'colors'
                              ? researchInfo.action.email.template
                                  .backgroundtext
                              : '#000000'
                          "
                          :text="item.text"
                          :item-id="i.toString()"
                          :index="i"
                          v-model="item.addQuestionAnswer"
                          :commentEnabled="item.commentEnabled"
                          :applicableEnabled="item.applicableEnabled"
                          :reviewAnswer="testNpsReview ? testNpsReview : -99"
                          :addQuestionTemplate="
                            researchInfo.addQuestionTemplate
                          "
                          @input="getReview"
                        />

                        <like-dislike
                          v-if="item.type === 'LIKE/DISLIKE'"
                          :item-id="i.toString()"
                          :textColor="
                            researchInfo.action.email.template.scale !==
                            'colors'
                              ? researchInfo.action.email.template
                                  .backgroundtext
                              : '#000000'
                          "
                          :questionText="item.text"
                          :index="i"
                          v-model="item.addQuestionAnswer"
                          :commentEnabled="item.commentEnabled"
                          :applicableEnabled="item.applicableEnabled"
                          :reviewAnswer="testNpsReview ? testNpsReview : -99"
                          :addQuestionTemplate="
                            researchInfo.addQuestionTemplate
                          "
                          @input="getReview"
                        />

                        <emotion
                          v-if="item.type === 'EMOTION'"
                          :textColor="
                            researchInfo.action.email.template.scale !==
                            'colors'
                              ? researchInfo.action.email.template
                                  .backgroundtext
                              : '#000000'
                          "
                          :questionText="item.text"
                          :index="i"
                          v-model="item.addQuestionAnswer"
                          :commentEnabled="item.commentEnabled"
                          :applicableEnabled="item.applicableEnabled"
                          :reviewAnswer="testNpsReview ? testNpsReview : -99"
                          :addQuestionTemplate="
                            researchInfo.addQuestionTemplate
                          "
                          @input="getReview"
                        />

                        <multiple-choices
                          :item-id="i.toString()"
                          v-if="item.type === 'MULTIPLE'"
                          :textColor="
                            researchInfo.action.email.template.scale !==
                            'colors'
                              ? researchInfo.action.email.template
                                  .backgroundtext
                              : '#000000'
                          "
                          :type="item.multipleType"
                          :questionText="item.text"
                          :choices="item.choices"
                          :index="i"
                          v-model="item.addQuestionAnswerMultiple"
                          :commentEnabled="item.commentEnabled"
                          :applicableEnabled="item.applicableEnabled"
                          :reviewAnswer="testNpsReview ? testNpsReview : -99"
                          :addQuestionTemplate="
                            researchInfo.addQuestionTemplate
                          "
                          @input="getReview"
                        />

                        <label-question
                          v-if="item.type === 'LABEL'"
                          :textColor="
                            researchInfo.action.email.template.scale !==
                            'colors'
                              ? researchInfo.action.email.template
                                  .backgroundtext
                              : '#000000'
                          "
                          :text="item.text"
                          :addQuestionTemplate="
                            researchInfo.addQuestionTemplate
                          "
                        />

                        <ces
                          v-if="item.type === 'CES'"
                          :textColor="
                            researchInfo.action.email.template.scale !==
                            'colors'
                              ? researchInfo.action.email.template
                                  .backgroundtext
                              : '#000000'
                          "
                          :text="item.text"
                          :item-id="i.toString()"
                          :index="i"
                          :colorTemplate="researchInfo.scale"
                          v-model="item.addQuestionAnswer"
                          :commentEnabled="item.commentEnabled"
                          :applicableEnabled="item.applicableEnabled"
                          :reviewAnswer="testNpsReview ? testNpsReview : -99"
                          :addQuestionTemplate="
                            researchInfo.addQuestionTemplate
                          "
                          @input="getReview"
                        />

                        <input-type
                          v-if="item.type === 'INPUT'"
                          :textColor="
                            researchInfo.action.email.template.scale !==
                            'colors'
                              ? researchInfo.action.email.template
                                  .backgroundtext
                              : '#000000'
                          "
                          :text="item.text"
                          :item-id="i.toString()"
                          :index="i"
                          v-model="item.answerText"
                          :addQuestionTemplate="
                            researchInfo.addQuestionTemplate
                          "
                          @input="getReview"
                          :isMandatoryForQuestion="researchInfo.mandatory"
                        />

                        <nps
                          v-if="item.type === 'NPS'"
                          :textColor="
                            researchInfo.action.email.template.scale !==
                            'colors'
                              ? researchInfo.action.email.template
                                  .backgroundtext
                              : '#000000'
                          "
                          :text="item.text"
                          :item-id="i.toString()"
                          :index="i"
                          :colorTemplate="researchInfo.scale"
                          v-model="item.addQuestionAnswer"
                          :commentEnabled="item.commentEnabled"
                          :applicableEnabled="item.applicableEnabled"
                          :reviewAnswer="testNpsReview ? testNpsReview : -99"
                          :addQuestionTemplate="
                            researchInfo.addQuestionTemplate
                          "
                          @input="getReview"
                        />

                        <likertEmotion
                          v-if="item.type === 'LIKERT/EMOTION'"
                          :textColor="
                            researchInfo.action.email.template.scale !==
                            'colors'
                              ? researchInfo.action.email.template
                                  .backgroundtext
                              : '#000000'
                          "
                          :text="item.text"
                          :item-id="i.toString()"
                          :index=i
                          :colorTemplate="researchInfo.scale"
                          v-model="item.addQuestionAnswer"
                          :commentEnabled="item.commentEnabled"
                          :applicableEnabled="item.applicableEnabled "
                          :reviewAnswer="testNpsReview ? testNpsReview : -99"
                          :addQuestionTemplate="researchInfo.addQuestionTemplate"
                          @input="getReview"
                        />
                      </template>
                    </template>
                  </template>

                  <template v-else>
                    <!-- all mandatory questions -->

                    <span
                      v-if="
                        displayRequiredFields && item.type !== 'LABEL' "
                      class="required"
                    >
                      *Obrigatório
                    </span>

                    <!-- -->

                    <!-- specific mandatory questions -->

                    <div
                      v-show="
                        showMessage &&
                        item.mandatory &&
                        item.type !== 'LABEL' &&
                        item.addQuestionAnswer &&
                        item.addQuestionAnswer.review === null
                      "
                    >
                      <span class="required"> *Obrigatório </span>
                    </div>

                    <div
                      v-show="
                        showMessage &&
                        item.mandatory &&
                        item.type === 'MULTIPLE' &&
                        item.addQuestionAnswerMultiple.multipleValues &&
                        item.addQuestionAnswerMultiple.multipleValues.length ===
                          0
                      "
                    >
                      <span class="required"> *Obrigatório </span>
                    </div>

                    <div
                      v-show="
                        (showMessage &&
                          item.mandatory &&
                          item.type === 'INPUT' &&
                          !item.answerText) ||
                        (item.answerText && item.answerText.review === null)
                      "
                    >
                      <span class="required"> *Obrigatório </span>
                    </div>

                    <!-- -->
                    <div v-for="(q, j) in researchInfo.additionalQuestions" :key="j">
                    <likert
                      v-if="
                      q.id === researchInfo.additionalQuestions[position].id &&
                      item.type === 'LIKERT' && !item.show"
                      :textColor="
                        researchInfo.action.email.template.scale !== 'colors'
                          ? researchInfo.action.email.template.backgroundtext
                          : '#000000'
                      "
                      :text="item.text"
                      :item-id="getIndex(item.id).toString()"
                      :index="getIndex(item.id)"
                      :colorTemplate="researchInfo.scale"
                      v-model="item.addQuestionAnswer"
                      :commentEnabled="item.commentEnabled"
                      :applicableEnabled="item.applicableEnabled"
                      :reviewAnswer="testNpsReview ? testNpsReview : -99"
                      :addQuestionTemplate="researchInfo.addQuestionTemplate"
                      :idQuestion="item.id"
                      @input="getReview"
                    />

                    <c-sat
                      v-if="
                      q.id === researchInfo.additionalQuestions[position].id &&
                      item.type === 'CSAT' && !item.show"
                      :textColor="
                        researchInfo.action.email.template.scale !== 'colors'
                          ? researchInfo.action.email.template.backgroundtext
                          : '#000000'
                      "
                      :text="item.text"
                      :item-id="getIndex(item.id).toString()"
                      :index="getIndex(item.id)"
                      :colorTemplate="researchInfo.scale"
                      v-model="item.addQuestionAnswer"
                      :commentEnabled="item.commentEnabled"
                      :applicableEnabled="item.applicableEnabled"
                      :reviewAnswer="testNpsReview ? testNpsReview : -99"
                      :addQuestionTemplate="researchInfo.addQuestionTemplate"
                      :idQuestion="item.id"
                      @input="getReview"
                    />
                    <star-rating
                      v-if="
                      q.id === researchInfo.additionalQuestions[position].id &&
                      item.type === 'REVIEWS' && !item.show"
                      :textColor="
                        researchInfo.action.email.template.scale !== 'colors'
                          ? researchInfo.action.email.template.backgroundtext
                          : '#000000'
                      "
                      :text="item.text"
                      :item-id="getIndex(item.id).toString()"
                      :index="getIndex(item.id)"
                      v-model="researchInfo.additionalQuestions[getIndex(item.id)].addQuestionAnswer"
                      :commentEnabled="item.commentEnabled"
                      :applicableEnabled="item.applicableEnabled"
                      :reviewAnswer="testNpsReview ? testNpsReview : -99"
                      :addQuestionTemplate="researchInfo.addQuestionTemplate"
                      :idQuestion="item.id"
                      @input="getReview"
                    />
                    <like-dislike
                      v-if="
                      q.id === researchInfo.additionalQuestions[position].id &&
                      item.type === 'LIKE/DISLIKE' && !item.show"
                      :textColor="
                        researchInfo.action.email.template.scale !== 'colors'
                          ? researchInfo.action.email.template.backgroundtext
                          : '#000000'
                      "
                      :questionText="item.text"
                      v-model="item.addQuestionAnswer"
                      :item-id="getIndex(item.id).toString()"
                      :index="getIndex(item.id)"
                      :commentEnabled="item.commentEnabled"
                      :applicableEnabled="item.applicableEnabled"
                      :reviewAnswer="testNpsReview ? testNpsReview : -99"
                      :addQuestionTemplate="researchInfo.addQuestionTemplate"
                      :idQuestion="item.id"
                      @input="getReview"
                    />

                    <emotion
                      v-if="
                      q.id === researchInfo.additionalQuestions[position].id &&
                      item.type === 'EMOTION' && !item.show"
                      :textColor="
                        researchInfo.action.email.template.scale !== 'colors'
                          ? researchInfo.action.email.template.backgroundtext
                          : '#000000'
                      "
                      :questionText="item.text"
                      v-model="item.addQuestionAnswer"
                      :item-id="getIndex(item.id).toString()"
                      :index="getIndex(item.id)"
                      :commentEnabled="item.commentEnabled"
                      :applicableEnabled="item.applicableEnabled"
                      :reviewAnswer="testNpsReview ? testNpsReview : -99"
                      :addQuestionTemplate="researchInfo.addQuestionTemplate"
                      :idQuestion="item.id"
                      @input="getReview"
                    />

                    <multiple-choices
                      v-if="
                      q.id === researchInfo.additionalQuestions[position].id &&
                      item.type === 'MULTIPLE' && !item.show"
                      :textColor="
                        researchInfo.action.email.template.scale !== 'colors'
                          ? researchInfo.action.email.template.backgroundtext
                          : '#000000'
                      "
                      :type="item.multipleType"
                      :questionText="item.text"
                      :choices="item.choices"
                      v-model="item.addQuestionAnswerMultiple"
                      :commentEnabled="item.commentEnabled"
                      :applicableEnabled="item.applicableEnabled"
                      :reviewAnswer="testNpsReview ? testNpsReview : -99"
                      :addQuestionTemplate="researchInfo.addQuestionTemplate"
                      :item-id="getIndex(item.id).toString()"
                      :index="getIndex(item.id)"
                      :idQuestion="item.id"
                      @input="getReview"
                    />

                    <ces
                      v-if="
                      q.id === researchInfo.additionalQuestions[position].id &&
                      item.type === 'CES' && !item.show"
                      :textColor="
                        researchInfo.action.email.template.scale !== 'colors'
                          ? researchInfo.action.email.template.backgroundtext
                          : '#000000'
                      "
                      :text="item.text"
                      :item-id="getIndex(item.id).toString()"
                      :index="getIndex(item.id)"
                      :colorTemplate="researchInfo.scale"
                      v-model="item.addQuestionAnswer"
                      :commentEnabled="item.commentEnabled"
                      :applicableEnabled="item.applicableEnabled"
                      :reviewAnswer="testNpsReview ? testNpsReview : -99"
                      :addQuestionTemplate="researchInfo.addQuestionTemplate"
                      :idQuestion="item.id"
                      @input="getReview"
                    />

                    <input-type
                      v-if="
                      q.id === researchInfo.additionalQuestions[position].id &&
                      item.type === 'INPUT' && !item.show"
                      :textColor="
                        researchInfo.action.email.template.scale !== 'colors'
                          ? researchInfo.action.email.template.backgroundtext
                          : '#000000'
                      "
                      :text="item.text"
                      :item-id="getIndex(item.id).toString()"
                      :index="getIndex(item.id)"
                      v-model="item.answerText"
                      :addQuestionTemplate="researchInfo.addQuestionTemplate"
                      :idQuestion="item.id"
                      @input="getReview"
                      :isMandatoryForQuestion="researchInfo.mandatory"
                    />

                    <label-question
                      v-if="
                      q.id === researchInfo.additionalQuestions[position].id &&
                      item.type === 'LABEL' && !item.show"
                      :textColor="
                        researchInfo.action.email.template.scale !== 'colors'
                          ? researchInfo.action.email.template.backgroundtext
                          : '#000000'
                      "
                      :text="item.text"
                      :item-id="getIndex(item.id).toString()"
                      :index="getIndex(item.id)"
                      :addQuestionTemplate="researchInfo.addQuestionTemplate"
                      :idQuestion="item.id"
                    />

                    <nps
                      v-if="
                      q.id === researchInfo.additionalQuestions[position].id &&
                      item.type === 'NPS' && !item.show"
                      :textColor="
                        researchInfo.action.email.template.scale !== 'colors'
                          ? researchInfo.action.email.template.backgroundtext
                          : '#000000'
                      "
                      :text="item.text"
                      :item-id="getIndex(item.id).toString()"
                      :index="getIndex(item.id)"
                      :colorTemplate="researchInfo.scale"
                      v-model="item.addQuestionAnswer"
                      :commentEnabled="item.commentEnabled"
                      :applicableEnabled="item.applicableEnabled"
                      :reviewAnswer="testNpsReview ? testNpsReview : -99"
                      :addQuestionTemplate="researchInfo.addQuestionTemplate"
                      :idQuestion="item.id"
                      @input="getReview"
                    />

                    <likertEmotion
                      v-if="
                      q.id === researchInfo.additionalQuestions[position].id &&
                      item.type === 'LIKERT/EMOTION' && !item.show"
                      :textColor="
                        researchInfo.action.email.template.scale !== 'colors'
                          ? researchInfo.action.email.template.backgroundtext
                          : '#000000'
                      "
                      :text="item.text"
                      :item-id="getIndex(item.id).toString()"
                      :index="getIndex(item.id)"
                      :colorTemplate="researchInfo.scale"
                      v-model="item.addQuestionAnswer"
                      :commentEnabled="item.commentEnabled"
                      :applicableEnabled="item.applicableEnabled"
                      :reviewAnswer="testNpsReview ? testNpsReview : -99"
                      :addQuestionTemplate="researchInfo.addQuestionTemplate"
                      :idQuestion="item.id"
                      @input="getReview"
                    />

                    <template
                      v-if="item.displayType === 'formSearch' && !item.show"
                    >
                      <contact
                        v-if="
                        q.id === researchInfo.additionalQuestions[position].id &&
                        item.type === 'CONTACT'"
                        :textColor="
                          researchInfo.action.email.template.backgroundtext
                        "
                        :type="item.multipleType"
                        :questionText="item.text"
                        :choices="item.choices"
                        :item-id="getIndex(item.id).toString()"
                        :index="getIndex(item.id)"
                        v-model="dataContact"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                      />
                    </template>
                    </div>
                  </template>
                </div>
              </div>
            </div>

            <div class="row" v-if="!viewAll">
              <div class="col-12 text-center">
                <button
                  v-if="position >= 0"
                  @click="prev"
                  class="btn px-5 py-2"
                >
                  <i class="fas fa-arrow-left" />
                  Voltar
                </button>

                <button class="btn btn-primary px-5 py-2" @click="next">
                  {{ step === 3 ? 'Finalizar' : 'Próximo' }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-2" v-if="viewAll">
          <div class="col-12">
            <hr v-if="researchInfo.additionalQuestions.length > 0" />

            <div v-for="(item, i) in researchInfo.additionalQuestions" :key="i">
              <div v-if="indicatorValuedQuestion(item)">
                <template v-if="item.profileEnabled">
                  <template
                    v-if="item.selectedProfile.includes(conditionalQuestion())"
                  >
                    <template
                      v-if="
                        promotersGrades.includes(testNpsReview) ||
                        detractorsGrades.includes(testNpsReview) ||
                        passivesGrades.includes(testNpsReview)
                      "
                    >
                      <!-- all mandatory questions -->

                      <span
                        v-if="displayRequiredFields && item.type !== 'LABEL'"
                        class="required"
                      >
                        *Obrigatório
                      </span>

                      <!-- -->

                      <!-- specific mandatory questions -->

                      <div
                        v-show="
                          showMessage &&
                          item.mandatory &&
                          item.type !== 'LABEL' &&
                          item.addQuestionAnswer &&
                          item.addQuestionAnswer.review === null
                        "
                      >
                        <span class="required"> *Obrigatório </span>
                      </div>

                      <div
                        v-show="
                          showMessage &&
                          item.mandatory &&
                          item.type === 'MULTIPLE' &&
                          item.addQuestionAnswerMultiple.multipleValues &&
                          item.addQuestionAnswerMultiple.multipleValues
                            .length === 0
                        "
                      >
                        <span class="required"> *Obrigatório </span>
                      </div>

                      <div
                        v-show="
                          (showMessage &&
                            item.mandatory &&
                            item.type === 'INPUT' &&
                            !item.answerText) ||
                          (item.answerText && item.answerText.review === null)
                        "
                      >
                        <span class="required"> *Obrigatório </span>
                      </div>

                      <!-- -->

                      <likert
                        v-if="item.type === 'LIKERT'"
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :text="item.text"
                        :item-id="i.toString()"
                        :index="i"
                        :colorTemplate="researchInfo.scale"
                        :commentEnabled="item.commentEnabled"
                        v-model="item.addQuestionAnswer"
                        :applicableEnabled="item.applicableEnabled"
                        :reviewAnswer="testNpsReview ? testNpsReview : -99"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        @input="getReview"
                      />

                      <c-sat
                        v-if="item.type === 'CSAT'"
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :text="item.text"
                        :item-id="i.toString()"
                        :index="i"
                        :colorTemplate="researchInfo.scale"
                        v-model="item.addQuestionAnswer"
                        :commentEnabled="item.commentEnabled"
                        :applicableEnabled="item.applicableEnabled"
                        :reviewAnswer="testNpsReview ? testNpsReview : -99"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        @input="getReview"
                      />

                      <star-rating
                        v-if="item.type === 'REVIEWS'"
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :text="item.text"
                        :item-id="i.toString()"
                        :index="i"
                        v-model="item.addQuestionAnswer"
                        :commentEnabled="item.commentEnabled"
                        :applicableEnabled="item.applicableEnabled"
                        :reviewAnswer="testNpsReview ? testNpsReview : -99"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        @input="getReview"
                      />

                      <like-dislike
                        v-if="item.type === 'LIKE/DISLIKE'"
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :questionText="item.text"
                        :index="i"
                        v-model="item.addQuestionAnswer"
                        :commentEnabled="item.commentEnabled"
                        :applicableEnabled="item.applicableEnabled"
                        :reviewAnswer="testNpsReview ? testNpsReview : -99"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        @input="getReview"
                      />

                      <emotion
                        v-if="item.type === 'EMOTION'"
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :questionText="item.text"
                        :index="i"
                        v-model="item.addQuestionAnswer"
                        :commentEnabled="item.commentEnabled"
                        :applicableEnabled="item.applicableEnabled"
                        :reviewAnswer="testNpsReview ? testNpsReview : -99"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        @input="getReview"
                      />

                      <multiple-choices
                        :item-id="i.toString()"
                        v-if="item.type === 'MULTIPLE'"
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :type="item.multipleType"
                        :questionText="item.text"
                        :choices="item.choices"
                        :index="i"
                        v-model="item.addQuestionAnswerMultiple"
                        :commentEnabled="item.commentEnabled"
                        :applicableEnabled="item.applicableEnabled"
                        :reviewAnswer="testNpsReview ? testNpsReview : -99"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        @input="getReview"
                      />

                      <label-question
                        v-if="item.type === 'LABEL'"
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :text="item.text"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                      />

                      <ces
                        v-if="item.type === 'CES'"
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :text="item.text"
                        :item-id="i.toString()"
                        :index="i"
                        :colorTemplate="researchInfo.scale"
                        v-model="item.addQuestionAnswer"
                        :commentEnabled="item.commentEnabled"
                        :applicableEnabled="item.applicableEnabled"
                        :reviewAnswer="testNpsReview ? testNpsReview : -99"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        @input="getReview"
                      />

                      <input-type
                        v-if="item.type === 'INPUT'"
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :text="item.text"
                        :item-id="i.toString()"
                        :index="i"
                        v-model="item.answerText"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        @input="getReview"
                        :isMandatoryForQuestion="researchInfo.mandatory"
                      />

                      <nps
                        v-if="item.type === 'NPS'"
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :text="item.text"
                        :item-id="i.toString()"
                        :index="i"
                        :colorTemplate="researchInfo.scale"
                        v-model="item.addQuestionAnswer"
                        :commentEnabled="item.commentEnabled"
                        :applicableEnabled="item.applicableEnabled"
                        :reviewAnswer="testNpsReview ? testNpsReview : -99"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        @input="getReview"
                      />

                      <likertEmotion
                        v-if="item.type === 'LIKERT/EMOTION'"
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :text="item.text"
                        :item-id="i.toString()"
                        :index="i"
                        :colorTemplate="researchInfo.scale"
                        v-model="item.addQuestionAnswer"
                        :commentEnabled="item.commentEnabled"
                        :applicableEnabled="item.applicableEnabled"
                        :reviewAnswer="testNpsReview ? testNpsReview : -99"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        @input="getReview"
                      />
                    </template>
                  </template>
                </template>

                <template v-else>
                  <!-- all mandatory questions -->

                  <span
                    v-if="displayRequiredFields && item.type !== 'LABEL'"
                    class="required"
                  >
                    *Obrigatório
                  </span>

                  <!-- -->

                  <!-- specific mandatory questions -->

                  <div
                    v-show="
                      showMessage &&
                      item.mandatory &&
                      item.type !== 'LABEL' &&
                      item.addQuestionAnswer &&
                      item.addQuestionAnswer.review === null
                    "
                  >
                    <span class="required"> *Obrigatório </span>
                  </div>

                  <div
                    v-show="
                      showMessage &&
                      item.mandatory &&
                      item.type === 'MULTIPLE' &&
                      item.addQuestionAnswerMultiple.multipleValues &&
                      item.addQuestionAnswerMultiple.multipleValues.length === 0
                    "
                  >
                    <span class="required"> *Obrigatório </span>
                  </div>

                  <div
                    v-show="
                      (showMessage &&
                        item.mandatory &&
                        item.type === 'INPUT' &&
                        !item.answerText) ||
                      (item.answerText && item.answerText.review === null)
                    "
                  >
                    <span class="required"> *Obrigatório </span>
                  </div>

                  <!-- -->

                  <likert
                    v-if="item.type === 'LIKERT' && !item.show"
                    :textColor="
                      researchInfo.action.email.template.scale !== 'colors'
                        ? researchInfo.action.email.template.backgroundtext
                        : '#000000'
                    "
                    :text="item.text"
                    :item-id="i.toString()"
                    :index="i"
                    :colorTemplate="researchInfo.scale"
                    v-model="item.addQuestionAnswer"
                    :commentEnabled="item.commentEnabled"
                    :applicableEnabled="item.applicableEnabled"
                    :reviewAnswer="testNpsReview ? testNpsReview : -99"
                    :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    :idQuestion="item.id"
                    @input="getReview"
                  />

                  <c-sat
                    v-if="item.type === 'CSAT' && !item.show"
                    :textColor="
                      researchInfo.action.email.template.scale !== 'colors'
                        ? researchInfo.action.email.template.backgroundtext
                        : '#000000'
                    "
                    :text="item.text"
                    :item-id="i.toString()"
                    :index="i"
                    :colorTemplate="researchInfo.scale"
                    v-model="item.addQuestionAnswer"
                    :commentEnabled="item.commentEnabled"
                    :applicableEnabled="item.applicableEnabled"
                    :reviewAnswer="testNpsReview ? testNpsReview : -99"
                    :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    :idQuestion="item.id"
                    @input="getReview"
                  />

                  <star-rating
                    v-if="item.type === 'REVIEWS' && !item.show"
                    :textColor="
                      researchInfo.action.email.template.scale !== 'colors'
                        ? researchInfo.action.email.template.backgroundtext
                        : '#000000'
                    "
                    :text="item.text"
                    :item-id="i.toString()"
                    :index="i"
                    v-model="item.addQuestionAnswer"
                    :commentEnabled="item.commentEnabled"
                    :applicableEnabled="item.applicableEnabled"
                    :reviewAnswer="testNpsReview ? testNpsReview : -99"
                    :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    :idQuestion="item.id"
                    @input="getReview"
                  />

                  <like-dislike
                    v-if="item.type === 'LIKE/DISLIKE' && !item.show"
                    :textColor="
                      researchInfo.action.email.template.scale !== 'colors'
                        ? researchInfo.action.email.template.backgroundtext
                        : '#000000'
                    "
                    :questionText="item.text"
                    :index="i"
                    v-model="item.addQuestionAnswer"
                    :item-id="i.toString()"
                    :commentEnabled="item.commentEnabled"
                    :applicableEnabled="item.applicableEnabled"
                    :reviewAnswer="testNpsReview ? testNpsReview : -99"
                    :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    :idQuestion="item.id"
                    @input="getReview"
                  />

                  <emotion
                    v-if="item.type === 'EMOTION' && !item.show"
                    :textColor="
                      researchInfo.action.email.template.scale !== 'colors'
                        ? researchInfo.action.email.template.backgroundtext
                        : '#000000'
                    "
                    :questionText="item.text"
                    :index="i"
                    v-model="item.addQuestionAnswer"
                    :item-id="i.toString()"
                    :commentEnabled="item.commentEnabled"
                    :applicableEnabled="item.applicableEnabled"
                    :reviewAnswer="testNpsReview ? testNpsReview : -99"
                    :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    :idQuestion="item.id"
                    @input="getReview"
                  />

                  <multiple-choices
                    v-if="item.type === 'MULTIPLE' && !item.show"
                    :textColor="
                      researchInfo.action.email.template.scale !== 'colors'
                        ? researchInfo.action.email.template.backgroundtext
                        : '#000000'
                    "
                    :type="item.multipleType"
                    :questionText="item.text"
                    :choices="item.choices"
                    :index="i"
                    v-model="item.addQuestionAnswerMultiple"
                    :commentEnabled="item.commentEnabled"
                    :applicableEnabled="item.applicableEnabled"
                    :reviewAnswer="testNpsReview ? testNpsReview : -99"
                    :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    :item-id="i.toString()"
                    :idQuestion="item.id"
                    @input="getReview"
                  />

                  <ces
                    v-if="item.type === 'CES' && !item.show"
                    :textColor="
                      researchInfo.action.email.template.scale !== 'colors'
                        ? researchInfo.action.email.template.backgroundtext
                        : '#000000'
                    "
                    :text="item.text"
                    :item-id="i.toString()"
                    :index="i"
                    :colorTemplate="researchInfo.scale"
                    v-model="item.addQuestionAnswer"
                    :commentEnabled="item.commentEnabled"
                    :applicableEnabled="item.applicableEnabled"
                    :reviewAnswer="testNpsReview ? testNpsReview : -99"
                    :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    :idQuestion="item.id"
                    @input="getReview"
                  />

                  <input-type
                    v-if="item.type === 'INPUT' && !item.show"
                    :textColor="
                      researchInfo.action.email.template.scale !== 'colors'
                        ? researchInfo.action.email.template.backgroundtext
                        : '#000000'
                    "
                    :text="item.text"
                    :item-id="i.toString()"
                    :index="i"
                    v-model="item.answerText"
                    :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    :idQuestion="item.id"
                    @input="getReview"
                    :isMandatoryForQuestion="researchInfo.mandatory"
                  />

                  <label-question
                    v-if="item.type === 'LABEL' && !item.show"
                    :textColor="
                      researchInfo.action.email.template.scale !== 'colors'
                        ? researchInfo.action.email.template.backgroundtext
                        : '#000000'
                    "
                    :text="item.text"
                    :item-id="i.toString()"
                    :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    :idQuestion="item.id"
                  />

                  <nps
                    v-if="item.type === 'NPS' && !item.show"
                    :textColor="
                      researchInfo.action.email.template.scale !== 'colors'
                        ? researchInfo.action.email.template.backgroundtext
                        : '#000000'
                    "
                    :text="item.text"
                    :item-id="i.toString()"
                    :index="i"
                    :colorTemplate="researchInfo.scale"
                    v-model="item.addQuestionAnswer"
                    :commentEnabled="item.commentEnabled"
                    :applicableEnabled="item.applicableEnabled"
                    :reviewAnswer="testNpsReview ? testNpsReview : -99"
                    :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    :idQuestion="item.id"
                    @input="getReview"
                  />
                  <likertEmotion
                    v-if="item.type === 'LIKERT/EMOTION' && !item.show"
                    :textColor="
                      researchInfo.action.email.template.scale !== 'colors'
                        ? researchInfo.action.email.template.backgroundtext
                        : '#000000'
                    "
                    :text="item.text"
                    :item-id="i.toString()"
                    :index="i"
                    :colorTemplate="researchInfo.scale"
                    v-model="item.addQuestionAnswer"
                    :commentEnabled="item.commentEnabled"
                    :applicableEnabled="item.applicableEnabled"
                    :reviewAnswer="testNpsReview ? testNpsReview : -99"
                    :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    :idQuestion="item.id"
                    @input="getReview"
                  />
                  <template
                    v-if="
                      action.email.additionalQuestions[i].displayType ===
                        'formSearch' && !item.show
                    "
                  >
                    <contact
                      v-if="item.type === 'CONTACT'"
                      :textColor="
                        researchInfo.action.email.template.backgroundtext
                      "
                      :type="item.multipleType"
                      :questionText="item.text"
                      :choices="item.choices"
                      :index="i"
                      v-model="dataContact"
                      :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    />
                  </template>
                </template>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="
            (step === 3 || viewAll) && researchInfo.commentPosition === 'down'
          "
          class="row"
        >
          <div class="col-12">
            <div class="feedback-area mt-4">
              <research-replys
                :style="{
                  color:
                    researchInfo.action.email.template.scale !== 'colors'
                      ? researchInfo.action.email.template.backgroundtext
                      : '#000000',
                }"
                :metric="researchInfo.metric"
                :promotersReply="promotersQuestion"
                :neutralReply="neutralQuestion"
                :detractorsReply="detractorsQuestion"
                :grade="testNpsReview"
              />

              <span v-if="displayRequiredFields" class="required mt-2">
                *Obrigatório
              </span>

              <textarea
                v-model="feedback"
                name=""
                id="feedback"
                class="form-control"
                rows="4"
              ></textarea>
            </div>
          </div>

          <div class="col-12 text-center mt-3" v-if="!viewAll">
            <button @click="step = 2" class="btn px-5 py-2">
              <i class="fas fa-arrow-left" />
              Voltar
            </button>

            <button class="btn btn-primary px-5 py-2" @click="submit">
              Finalizar
            </button>
          </div>
        </div>

        <div class="row pt-2" v-if="researchInfo.enableAnonymous">
          <b-form-checkbox
            :disabled="researchInfo.action.allAnswersAnonymous"
            class="check-alert-modal ml-3"
            id="id-anonymous"
            v-model="anonymousResponse"
          >
          </b-form-checkbox>

          <label
            for="id-anonymous"
            :style="{
              color:
                researchInfo.action.email.template.scale !== 'colors'
                  ? researchInfo.action.email.template.backgroundtext
                  : '#000000',
            }"
          >
            {{ researchInfo.enableAnonymous }}
          </label>
        </div>

        <div v-if="enabledAudioResponse">
          <audio-recorder
            format="mp3"
            :bit-rate="128"
            upload-url="YOUR_API_URL"
            :attempts="1"
            :time="1"
            :headers="headers"
            :before-recording="callback"
            :pause-recording="callback"
            :after-recording="callback"
            :select-record="callback"
            :before-upload="callback"
            :successful-upload="callback"
            :failed-upload="callback"
          />
        </div>

        <div class="row mt-5" v-if="viewAll">
          <div class="col-12 text-center mt-2 mb-3 btn-send">
            <template v-if="typeModalContact">
              <b-button
                v-b-modal.modal-send
                @click="submit"
                :style="{
                  boxShadow: `0px 10px 30px -7px ${
                    researchInfo.action.email.template.buttonColor || '#cccccc'
                  }`,
                  backgroundColor: researchInfo.action.email.template
                    .buttonColor
                    ? researchInfo.action.email.template.buttonColor
                    : '',
                  borderColor: researchInfo.action.email.template
                    .buttonBorderColor
                    ? researchInfo.action.email.template.buttonBorderColor
                    : '',
                  color: researchInfo.action.email.template.buttonTextColor
                    ? researchInfo.action.email.template.buttonTextColor
                    : '',
                }"
                variant="btn btn-primary"
              >
                Enviar!
              </b-button>

              <template class="modal-answer" v-if="validateFields">
                <b-modal
                  id="modal-send"
                  ref="my-modal"
                  hide-footer
                  hide-header
                  :no-close-on-backdrop="true"
                  hide-header-close
                >
                  <b-button class="close-button" @click="hideModal">X</b-button>

                  <div class="row mt-2">
                    <div class="col-12">
                      <div
                        v-for="(item, i) in action.email.additionalQuestions"
                        :key="i"
                      >
                        <contact
                          v-if="item.type === 'CONTACT'"
                          :type="item.displayType"
                          :questionText="item.text"
                          :choices="item.choices"
                          :addQuestionTemplate="
                            researchInfo.addQuestionTemplate
                          "
                          :index="position"
                          v-model="dataContact"
                        />
                      </div>

                      <span v-if="displayRequiredFields" class="required mt-2">
                        *Campos obrigatórios
                      </span>
                    </div>
                  </div>

                  <b-button
                    class="mt-3"
                    block
                    variant="btn btn-primary"
                    @click="updateContactInfo"
                  >
                    Enviar
                  </b-button>
                </b-modal>
              </template>
            </template>

            <template v-else>
              <template>
                <button
                  :disabled="loadingSubmit"
                  :style="{
                    boxShadow: `0px 10px 30px -7px ${
                      researchInfo.action.email.template.buttonColor ||
                      '#cccccc'
                    }`,
                    backgroundColor: researchInfo.action.email.template
                      .buttonColor
                      ? researchInfo.action.email.template.buttonColor
                      : '',
                    borderColor: researchInfo.action.email.template
                      .buttonBorderColor
                      ? researchInfo.action.email.template.buttonBorderColor
                      : '',
                    color: researchInfo.action.email.template.buttonTextColor
                      ? researchInfo.action.email.template.buttonTextColor
                      : '',
                  }"
                  class="btn btn-primary px-5 py-2 btn-shadow"
                  @click="submit"
                >
                  {{
                    researchInfo.action.email.template.submitButtonValue ||
                    $t('researchPage.send')
                  }}
                </button>
              </template>
            </template>
          </div>
        </div>

        <div class="row">
          <div class="col-12 text-center mt-5">
            <hr />

            <div
              class="template-footer-modal mt-4 mb-4"
              v-if="researchInfo.footer"
            >
              <a href="https://www.indecx.com.br/">
                <img
                  src="../../../assets/logo-indecx.png"
                  style="width: 80px;"
                />
              </a>
            </div>
          </div>
        </div>

        <div v-if="researchInfo.textprivacyPolicy" class="row">
          <div class="col-12 text-center mb-4">
            <span style="font-size: 0.9em;">
              <a
                :href="researchInfo.linkprivacyPolicy"
                style="color: #212529;"
                target="_blank"
                :style="{
                  color:
                    researchInfo.action.email.template.scale !== 'colors'
                      ? researchInfo.action.email.template.backgroundtext
                      : '#000000',
                }"
              >
                {{ researchInfo.textprivacyPolicy }}
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="loadingSubmit" v-if="sendLoading">
      <Spinner name="wave" color="#86f470" />
      <span style="color: #fff; font-size: 20px; margin-left: -18px;"
        >Enviando...</span
      >
    </div> -->
  </div>
</template>

<script>
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { mapState, mapActions } from 'vuex';
import swal from 'sweetalert';
import Spinner from 'vue-spinkit';
import bowser from 'bowser';
import axios from 'axios';
import cSat from '@/components/molecules/metrics/csat';
import nps from '@/components/molecules/metrics/nps';
import ces from '@/components/molecules/metrics/ces';
import likert from '@/components/molecules/metrics/likert';
import starRating from '@/components/molecules/metrics/reviews';
import likeDislike from '@/components/molecules/metrics/like-dislike';
import emotion from '@/components/molecules/metrics/emotion';
import multipleChoices from '@/components/molecules/metrics/multiple-choices';
import inputType from '@/components/molecules/metrics/input-type';
import contact from '@/components/molecules/metrics/contact';
import labelQuestion from '@/components/molecules/metrics/label-question';
import methodology from '@/components/molecules/action-templates/methodology';
import researchReplys from '@/components/atoms/research-replys';
import likertEmotion from '@/components/molecules/metrics/likert-emotion';
import validator from 'validator';
import Unavailable from '@/components/pages/unavailable';
import api from '../../../services/api';

export default {
  components: {
    methodology,
    cSat,
    nps,
    likert,
    starRating,
    likeDislike,
    emotion,
    multipleChoices,
    inputType,
    contact,
    researchReplys,
    labelQuestion,
    Spinner,
    ces,
    Unavailable,
    likertEmotion,
  },
  data: () => ({
    viewAll: false,
    step: 1,
    loadingSave: false,
    timerValue: 0,
    audio: null,
    enabledAudioResponse: false,
    headers: {
      'X-Custom-Header': 'somedata',
    },
    anonymousResponse: false,
    researchInfo: {
      reply: {},
      additionalQuestions: [],
    },
    dataContact: {
      name: null,
      email: null,
      phone: null,
    },
    logo: null,
    error: false,
    loading: true,
    answer: {},
    userAuth: null,
    feedback: '',
    apiRoot: null,
    apiServerless: null,
    loadingSubmit: false,
    errorMsg: null,
    displayRequiredFields: false,
    validateInput: false,
    indicators: [],
    action: {},
    typeModalContact: false,
    answerId: null,
    validateFields: true,
    promotersGrades: [5, 4],
    passivesGrades: [3],
    detractorsGrades: [2, 1],
    closingMessage: {
      useLogo: false,
      html: null,
    },
    displayClosingMessage: false,
    closingMessageType: 'default',
    isLinkChannel: false,
    promotersQuestion: null,
    neutralQuestion: null,
    detractorsQuestion: null,
    company: null,
    sendLoading: false,
    afterAnswer: false,
    positionQuestion: null,
    showMessage: false,
    visitorId: null,
    position: 0,
    isGrouped: false,
  }),
  methods: {
    ...mapActions('actions', ['setTestNpsReview']),
    next() {
      const length = this.isGrouped
        ? this.pages.length
        : this.researchInfo.additionalQuestions.length;
      if (this.position >= 0 && this.position + 1 < length) {
        this.step = 2;
        this.position += 1;
      } else if (this.position + 1 === length) {
        this.step = 3;
      }
    },
    prev() {
      if (this.position === 0) {
        this.step = 1;
      }
      if (this.position > 0) {
        this.position -= 1;
      }
    },
    startTimerToReloadPage() {
      const timer = setInterval(() => {
        this.timerValue += 1;
        if (this.timerValue >= 100) {
          window.location.reload();
          clearInterval(timer);
        }
      }, 100);
    },
    getIndex(id){
      return this.researchInfo.additionalQuestions.findIndex(item => item.id === id);
    },
    isVisible(item, value) {
      if (item.logicalRuleEnabled && item.conditionalRule) {
        let res = false;
        switch (item.conditionalRule) {
          case 'equal':
            if (item.type === 'MULTIPLE') {
              if (item.multipleType === 'radio') {
                res =
                  value.multipleValues === item.conditionalValue ? true : false;
              } else {
                res = value.multipleValues.includes(item.conditionalValue);
              }
            } else {
              res =
                Number(value.review) === item.conditionalValue ? true : false;
            }
            break;

          case 'differentThan':
            if (item.type === 'MULTIPLE') {
              if (item.multipleType === 'radio') {
                res =
                  value.multipleValues !== item.conditionalValue ? true : false;
              } else {
                res = value.multipleValues.includes(item.conditionalValue);
              }
            } else {
              res =
                Number(value.review) !== item.conditionalValue ? true : false;
            }
            break;

          case 'biggerThen':
            res = value.review > item.conditionalValue ? true : false;
            break;

          case 'greaterOrEqualTo':
            res = value.review >= item.conditionalValue ? true : false;
            break;

          case 'lessThan':
            res = value.review < item.conditionalValue ? true : false;
            break;

          case 'lessThanOrEqualTo':
            res = value.review <= item.conditionalValue ? true : false;
            break;

          default:
            break;
        }
        return res;
      }
      return false;
    },

    getReview(value) {
      const index = Number(value.position);
      const item = this.researchInfo.additionalQuestions[index];

      let gradeQuestion = null;
      this.researchInfo.additionalQuestions[index].answerText = value.review;

      if (item.type !== 'MULTIPLE' && item.type !== 'INPUT') {
        gradeQuestion = value.review;
      } else if (item.type === 'INPUT') {
        gradeQuestion = value.review;
      } else {
        gradeQuestion = value.multipleValues;
      }

      this.$set(
        this.researchInfo.additionalQuestions[index],
        'gradeAddQuestion',
        gradeQuestion,
      );

      if (item.idsDisabled && item.idsDisabled.length > 0) {
        item.idsDisabled.forEach((el) => {
          for (
            let i = 0;
            i < this.researchInfo.additionalQuestions.length;
            i += 1
          ) {
            if (this.researchInfo.additionalQuestions[i].id === el) {
              this.researchInfo.additionalQuestions[i].show = this.isVisible(
                item,
                value,
              );
            }
          }
        });

        const arr = this.researchInfo.additionalQuestions;
        this.researchInfo.additionalQuestions = [];
        this.researchInfo.additionalQuestions = arr;
      }
    },

    callback(ev) {
      if (ev.blob) {
        this.audio = ev.blob;
      }
    },
    async blobToBase64(blob) {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    },
    conditionalQuestion() {
      if (this.promotersGrades.includes(this.testNpsReview)) {
        return 'promotor';
      } else if (this.detractorsGrades.includes(this.testNpsReview)) {
        return 'detrator';
      }

      return 'neutro';
    },

    hideModal() {
      this.$refs['my-modal'].hide();
      this.updateContactInfo();
    },
    async submit() {
      this.loadingSubmit = true;

      if(this.enabledAudioResponse){
        this.enabledAudioResponse = false;
        setTimeout(()=>{
          this.enabledAudioResponse = true
        });

        if(!this.audio){
            await new Promise(resolve => setTimeout(resolve, 800));
        };
      };


      const validate = this.verifyFields();

      if (validate) {
        this.answer.companyId = this.action.companyId;
        this.answer.actionId = this.$route.params.actionId;
        this.answer.name = this.dataContact.name;
        this.answer.email = this.dataContact.email;
        this.answer.phone = this.dataContact.phone;
        this.answer.review = this.testNpsReview;
        this.answer.feedback = this.feedback;
        this.answer.additionalQuestions = this.researchInfo.additionalQuestions;
        this.answer.channel = this.isLinkChannel ? 'link' : 'qrcode';
        this.answer.token = null;
        this.answer.indicators = this.indicators;
        this.answer.anonymousResponse = !this.researchInfo.enableAnonymous
          ? this.researchInfo.enableAnonymous
          : this.anonymousResponse;

        this.answer.deviceInfo = this.getDeviceInfo();
        this.answer.deviceInfo.visitorId = this.visitorId;

        this.answer.additionalQuestions.forEach((el, index) => {
          if (el.addQuestionAnswer) {
            el.review = el.addQuestionAnswer.review;
            el.comment = el.addQuestionAnswer.comment || undefined;

            if (this.getConditionalQuestion(el) !== '') {
              el.conditionalQuestion = this.getConditionalQuestion(el);
            }

            el.isAnswered = this.getIsAnswered(el);
          }

          if (this.getConditionalQuestion(el) !== '') {
            el.conditionalQuestion = this.getConditionalQuestion(el);
          }

          delete this.answer.additionalQuestions[index].addQuestionAnswer;

          if (el.addQuestionAnswerMultiple) {
            el.multipleValues =
              el.addQuestionAnswerMultiple.multipleValues || [];
            el.comment = el.addQuestionAnswerMultiple.comment || undefined;
            el.conditionalQuestion = this.getConditionalQuestion(el);
            el.isAnswered = this.getIsAnswered(el);
          }

          delete this.answer.additionalQuestions[index]
            .addQuestionAnswerMultiple;
        });

        try {
          let response;

          if (this.audio) {
            this.answer.audioBase64 = await this.blobToBase64(this.audio);
          } else {
            this.answer.audioBase64 = null;
          }

          if (this.company.enableServerless && this.apiServerless) {
            response = await axios.post(`${this.apiServerless}/answer-qrcode`, {
              answer: this.answer,
            });
          } else {
            response = await api.post(`/qrcode-answers`, {
              answer: this.answer,
            });
          }

          this.answerId = response.data._id;

          this.handleClosingMessage();

          if (!this.typeModalContact) {
            this.displayClosingMessage = true;
            this.startTimerToReloadPage();
          }
        } catch (error) {
          swal(
            this.$t('researchPage.errorMsg.title'),
            this.$t('researchPage.errorMsg.description'),
            'error',
          );
        }
      } else {
        swal('Oops...', this.errorMsg, 'warning');
      }
      this.loadingSubmit = false;
    },
    async updateContactInfo() {
      if (this.displayRequiredFields) {
        let isValid = true;
        for (
          let i = 0;
          i < this.researchInfo.additionalQuestions.length;
          i += 1
        ) {
          const question = this.researchInfo.additionalQuestions[i];
          if (question.type === 'CONTACT') {
            const contactTypes = question.choices || [];
            const hasName = contactTypes.indexOf('name');
            const hasPhone = contactTypes.indexOf('phone');
            if (hasName >= 0 && !this.dataContact.name) {
              isValid = false;
              break;
            }
            if (
              this.dataContact.email &&
              !validator.isEmail(this.dataContact.email)
            ) {
              swal(
                this.$t('researchPage.errorMsg.title'),
                'Insira um e-mail válido',
                'warning',
              );
            }
            if (hasPhone >= 0 && !this.dataContact.phone) {
              isValid = false;
              break;
            }
          }
        }
        if (isValid) {
          if (this.company.enableServerless && this.apiServerless) {
            await axios.put(
              `${this.apiServerless}/answer/data-contact/${this.answerId}`,
              {
                name: this.dataContact.name,
                email: this.dataContact.email,
                phone: this.dataContact.phone,
              },
            );
          } else {
            await api.put(`/answer/data-contact/${this.answerId}`, {
              name: this.dataContact.name,
              email: this.dataContact.email,
              phone: this.dataContact.phone,
            });
          }
          this.displayClosingMessage = true;
          this.startTimerToReloadPage();
        }
      } else if (
        this.dataContact.email &&
        !validator.isEmail(this.dataContact.email)
      ) {
        swal(
          this.$t('researchPage.errorMsg.title'),
          'Insira um e-mail válido',
          'warning',
        );
      } else {
        if (this.company.enableServerless && this.apiServerless) {
          await axios.put(
            `${this.apiServerless}/answer/data-contact/${this.answerId}`,
            {
              name: this.dataContact.name,
              email: this.dataContact.email,
              phone: this.dataContact.phone,
            },
          );
        } else {
          await api.put(`/answer/data-contact/${this.answerId}`, {
            name: this.dataContact.name,
            email: this.dataContact.email,
            phone: this.dataContact.phone,
          });
        }

        this.displayClosingMessage = true;
        this.startTimerToReloadPage();
      }
    },

    fillArrayAll() {
      const arr = [];

      this.researchInfo.additionalQuestions.forEach((el) => {
        if (el.selectedProfile) {
          if (
            this.promotersGrades.includes(this.testNpsReview) &&
            el.selectedProfile.includes('promotor') &&
            !el.show
          ) {
            arr.push({
              answerText: el.answerText,
              applicableEnabled: el.applicableEnabled,
              commentEnabled: el.commentEnabled,
              profileEnabled: el.profileEnabled,
              review: el.addQuestionAnswer ? el.addQuestionAnswer.review : null,
              selectedProfile: el.selectedProfile,
              text: el.text,
              type: el.type,
              addQuestionAnswerMultiple: el.addQuestionAnswerMultiple,
              choices: el.choices,
              indicatorValue: el.indicatorValue,
              indicatorValueEnabled: el.indicatorValueEnabled,
              selectedIndicator: el.selectedIndicator,
              feedback: el.feedback,
              mandatory: el.mandatory,
            });
          } else if (
            this.passivesGrades.includes(this.testNpsReview) &&
            el.selectedProfile.includes('neutro') &&
            !el.show
          ) {
            arr.push({
              answerText: el.answerText,
              applicableEnabled: el.applicableEnabled,
              commentEnabled: el.commentEnabled,
              profileEnabled: el.profileEnabled,
              review: el.addQuestionAnswer ? el.addQuestionAnswer.review : null,
              selectedProfile: el.selectedProfile,
              text: el.text,
              type: el.type,
              addQuestionAnswerMultiple: el.addQuestionAnswerMultiple,
              choices: el.choices,
              indicatorValue: el.indicatorValue,
              indicatorValueEnabled: el.indicatorValueEnabled,
              selectedIndicator: el.selectedIndicator,
              feedback: el.feedback,
              mandatory: el.mandatory,
            });
          } else if (
            this.detractorsGrades.includes(this.testNpsReview) &&
            el.selectedProfile.includes('detrator') &&
            !el.show
          ) {
            arr.push({
              answerText: el.answerText,
              applicableEnabled: el.applicableEnabled,
              commentEnabled: el.commentEnabled,
              profileEnabled: el.profileEnabled,
              review: el.addQuestionAnswer ? el.addQuestionAnswer.review : null,
              selectedProfile: el.selectedProfile,
              text: el.text,
              type: el.type,
              addQuestionAnswerMultiple: el.addQuestionAnswerMultiple,
              choices: el.choices,
              indicatorValue: el.indicatorValue,
              indicatorValueEnabled: el.indicatorValueEnabled,
              selectedIndicator: el.selectedIndicator,
              feedback: el.feedback,
              mandatory: el.mandatory,
            });
          }
        } else if (!el.show || el.logicalRuleEnabled) {
          arr.push({
            answerText: el.answerText,
            applicableEnabled: el.applicableEnabled,
            commentEnabled: el.commentEnabled,
            profileEnabled: el.profileEnabled,
            review: el.addQuestionAnswer ? el.addQuestionAnswer.review : null,
            selectedProfile: el.selectedProfile,
            text: el.text,
            type: el.type,
            addQuestionAnswerMultiple: el.addQuestionAnswerMultiple,
            choices: el.choices,
            indicatorValue: el.indicatorValue,
            indicatorValueEnabled: el.indicatorValueEnabled,
            selectedIndicator: el.selectedIndicator,
            feedback: el.feedback,
            mandatory: el.mandatory,
          });
        } else if (
          (el.selectedProfile === null && !el.show) ||
          (el.selectedProfile === undefined && !el.show)
        ) {
          arr.push({
            answerText: el.answerText,
            applicableEnabled: el.applicableEnabled,
            commentEnabled: el.commentEnabled,
            profileEnabled: el.profileEnabled,
            review: el.addQuestionAnswer ? el.addQuestionAnswer.review : null,
            selectedProfile: el.selectedProfile,
            text: el.text,
            type: el.type,
            addQuestionAnswerMultiple: el.addQuestionAnswerMultiple,
            choices: el.choices,
            indicatorValue: el.indicatorValue,
            indicatorValueEnabled: el.indicatorValueEnabled,
            selectedIndicator: el.selectedIndicator,
            feedback: el.feedback,
            mandatory: el.mandatory,
          });
        }
      });

      return arr;
    },

    verifyFields() {
      this.errorMsg = null;

      if (this.researchInfo.allAnswersRequired) {
        let isValid = true;

        let arr = [];

        arr = this.fillArrayAll();

        for (let i = 0; i < arr.length; i += 1) {
          const question = arr[i];

          const showQuestion = this.indicatorValuedQuestion(question);

          if (showQuestion) {
            if (
              !question.review &&
              question.review !== 0 &&
              question.type !== 'MULTIPLE' &&
              question.type !== 'LABEL' &&
              question.type !== 'INPUT' &&
              question.type !== 'CONTACT'
            ) {
              isValid = false;
              this.validateFields = false;
              break;
            }
            if (question.type !== 'LABEL') {
              if (question.type === 'MULTIPLE') {
                if (
                  question.addQuestionAnswerMultiple.multipleValues.length <= 0
                ) {
                  isValid = false;
                  this.validateFields = false;
                  break;
                }
              } else if (question.type === 'INPUT') {
                if (!question.answerText) {
                  isValid = false;
                  this.validateFields = false;
                  break;
                }
              } else if (question.type === 'CONTACT') {
                const contactTypes = question.choices || [];
                const hasName = contactTypes.indexOf('name');
                const hasEmail = contactTypes.indexOf('email');
                const hasPhone = contactTypes.indexOf('phone');

                if (question.displayType === 'formSearch') {
                  if (hasName >= 0 && !this.dataContact.name) {
                    isValid = false;
                    this.validateFields = false;
                    break;
                  }

                  if (hasEmail >= 0 && !this.dataContact.email) {
                    isValid = false;
                    this.validateFields = false;
                    break;
                  }

                  if (hasPhone >= 0 && !this.dataContact.phone) {
                    isValid = false;
                    this.validateFields = false;
                    break;
                  }
                }
              } else if (
                this.testNpsReview === null ||
                this.testNpsReview === undefined
              ) {
                isValid = false;
                this.validateFields = false;
                break;
              }
            }
          }
        }

        if (!this.feedback) {
          isValid = false;
          this.validateFields = false;
        }

        if (!isValid) {
          this.errorMsg = 'Por favor, preencha todos os campos obrigatórios.';
          this.displayRequiredFields = true;
        }
      }

      if (this.researchInfo.customMandatoryQuestion) {
        let isValid = true;

        let arr = [];

        arr = this.fillArrayAll();

        let fields = [];

        arr.forEach((element) => {
          if (element.type !== 'REVIEWS') {
            fields = arr.filter(
              (item) => item.mandatory && item.review === null,
            );
          }
        });

        if (fields.length) {
          this.showMessage = true;
        } else {
          this.showMessage = false;
        }

        for (let i = 0; i < arr.length; i += 1) {
          const question = arr[i];

          const showQuestion = this.indicatorValuedQuestion(question);

          if (showQuestion) {
            if (
              !question.review &&
              question.review !== 0 &&
              question.type !== 'MULTIPLE' &&
              question.type !== 'LABEL' &&
              question.type !== 'INPUT' &&
              question.type !== 'CONTACT' &&
              question.mandatory
            ) {
              this.validateFields = false;
              isValid = false;
              break;
            }
            if (question.type !== 'LABEL') {
              if (question.type === 'MULTIPLE') {
                if (
                  question.addQuestionAnswerMultiple.multipleValues.length <= 0
                ) {
                  this.validateFields = false;
                  isValid = false;
                  break;
                }
              } else if (question.type === 'INPUT') {
                if (!question.answerText && question.mandatory) {
                  this.validateFields = false;
                  isValid = false;
                  break;
                }
              } else if (question.type === 'CONTACT') {
                const contactTypes = question.choices || [];
                const hasName = contactTypes.indexOf('name');
                const hasEmail = contactTypes.indexOf('email');
                const hasPhone = contactTypes.indexOf('phone');

                if (question.displayType === 'formSearch') {
                  if (hasName >= 0 && !this.dataContact.name) {
                    this.validateFields = false;
                    isValid = false;
                    break;
                  }

                  if (hasEmail >= 0 && !this.dataContact.email) {
                    this.validateFields = false;
                    isValid = false;
                    break;
                  }

                  if (hasPhone >= 0 && !this.dataContact.phone) {
                    this.validateFields = false;
                    isValid = false;
                    break;
                  }
                }
              } else if (
                this.testNpsReview === null ||
                this.testNpsReview === undefined
              ) {
                this.validateFields = false;
                isValid = false;
                break;
              }
            }
          }
        }

        if (!isValid) {
          this.errorMsg = 'Por favor, preencha todos os campos obrigatórios.';
        }
      }

      if (!Number.isInteger(this.testNpsReview)) {
        this.errorMsg =
          'Por favor, responda nossa pergunta principal para enviar a resposta.';
      }

      if (
        this.researchInfo.metric === 'nps-0-10' &&
        this.testNpsReview < 0 &&
        this.testNpsReview > 10
      ) {
        this.errorMsg =
          'Por favor, responda nossa pergunta principal para enviar a resposta.';
      }

      if (
        this.researchInfo.metric === 'nps-1-5' &&
        this.testNpsReview < 1 &&
        this.testNpsReview > 5
      ) {
        this.errorMsg =
          'Por favor, responda nossa pergunta principal para enviar a resposta.';
      }

      if (
        this.dataContact.email &&
        !validator.isEmail(this.dataContact.email)
      ) {
        this.errorMsg = 'Por favor, insira um e-mail válido.';
      }

      if (this.errorMsg) {
        this.validateFields = false;
        return false;
      }

      this.validateFields = true;
      return true;
    },

    handleClosingMessage() {
      if (
        this.researchInfo.closingMessageEnabled &&
        this.researchInfo.closingMessage
      ) {
        if (this.researchInfo.closingMessage.dynamic) {
          if (
            this.researchInfo.closingMessage.promoters &&
            this.promotersGrades.includes(this.testNpsReview)
          ) {
            this.closingMessage.useLogo = this.researchInfo.closingMessage.promoters.useLogo;
            this.closingMessage.html = this.researchInfo.closingMessage.promoters.html;
          } else if (
            this.researchInfo.closingMessage.passives &&
            this.passivesGrades.includes(this.testNpsReview)
          ) {
            this.closingMessage.useLogo = this.researchInfo.closingMessage.passives.useLogo;
            this.closingMessage.html = this.researchInfo.closingMessage.passives.html;
          } else if (
            this.researchInfo.closingMessage.detractors &&
            this.detractorsGrades.includes(this.testNpsReview)
          ) {
            this.closingMessage.useLogo = this.researchInfo.closingMessage.detractors.useLogo;
            this.closingMessage.html = this.researchInfo.closingMessage.detractors.html;
          }
        } else if (this.researchInfo.closingMessage.default) {
          this.closingMessage.useLogo = this.researchInfo.closingMessage.default.useLogo;
          this.closingMessage.html = this.researchInfo.closingMessage.default.html;
        }
        this.closingMessage.html = this.closingMessage.html.replace(
          /<img src/gi,
          '<img style="max-width: 100%;" src',
        );
      }
    },

    getIsAnswered(questions) {
      if (questions.profileEnabled) {
        if (questions.conditionalQuestion) {
          if (questions.review) {
            return true;
          }

          if (questions.type === 'MULTIPLE') {
            if (questions.multipleValues.length > 0) {
              return true;
            }
            return false;
          }

          return false;
        }
      }

      return null;
    },

    getConditionalQuestion(questions) {
      if (questions.profileEnabled && !questions.show) {
        return questions.selectedProfile;
      } else if (
        (questions.logicalRuleEnabled && !questions.show) ||
        (!questions.logicalRuleEnabled && !questions.show)
      ) {
        return null;
      }

      return '';
    },

    getDeviceInfo() {
      let deviceInfo = null;
      try {
        deviceInfo = bowser.parse(window.navigator.userAgent);
      } catch (error) {
        window.console.log(error);
      }
      return deviceInfo;
    },
    async loadDeviceUUID() {
      const useFingerprintJS = false;
      if(useFingerprintJS){
        const fpPromise = FingerprintJS.load();
        const fp = await fpPromise;
        const result = await fp.get();
        this.visitorId = result.visitorId;
      } else {
        // Obter informações do navegador
        const browserInfo = {
          userAgent: navigator.userAgent,
          cooke: document.cookie
        };

        // Obter informações de resolução
        const resolution = {
          screenWidth: screen.width,
          screenHeight: screen.height,
          devicePixelRatio: window.devicePixelRatio
        };

        // Combinar informações em um objeto
        const hashInfo = {
          browser: browserInfo,
          resolution: resolution
        };

        // Codificar o objeto em uma string JSON e depois em base64
        const hash = btoa(JSON.stringify(hashInfo));

        this.visitorId = hash;
      }
    },
    replaceTagsOnText(researchInfo, value) {
      const arrayOfTags = [];
      arrayOfTags.push(
        {
          key: 'nota',
          value: value ? value : ' ',
        },
        {
          key: 'pnota',
          value: value ? value : ' ',
        },
      );
      let promoters = researchInfo.reply.promoters;
      let neutral = researchInfo.reply.neutral;
      let detractors = researchInfo.reply.detractors;
      arrayOfTags.forEach((tag) => {
        const regexTags = new RegExp(`<${tag.key}>`, 'gi');
        if (tag.value === ' ') {
          tag.value = 0;
        }
        if (promoters) {
          promoters = promoters.replace(regexTags, tag.value);
        }
        this.promotersQuestion = promoters;
        if (neutral) {
          neutral = neutral.replace(regexTags, tag.value);
        }
        this.neutralQuestion = neutral;
        if (detractors) {
          detractors = detractors.replace(regexTags, tag.value);
        }
        this.detractorsQuestion = detractors;
      });
    },
    indicatorValuedQuestion(item) {
      if (item.indicatorValueEnabled) {
        for (let i = 0; i < this.indicators.length; i += 1) {
          if (item.indicatorCriterion === 'equal') {
            if (
              item.selectedIndicator &&
              this.indicators[i].column.toLowerCase() ===
              item.selectedIndicator.toLowerCase()
            ) {
              if (
                this.indicators[i].value.toLowerCase() ===
                item.indicatorValue.toLowerCase()
              ) {
                return true;
              }
              break;
            }
          } else if (item.indicatorCriterion === 'different') {
            if (
              item.selectedIndicator &&
              this.indicators[i].column.toLowerCase() ===
              item.selectedIndicator.toLowerCase()
            ) {
              if (
                this.indicators[i].value.toLowerCase() !==
                item.indicatorValue.toLowerCase()
              ) {
                return true;
              }
              break;
            }
          } else if (item.indicatorCriterion === 'contains') {
            if (
              item.selectedIndicator &&
              this.indicators[i].column.toLowerCase() ===
              item.selectedIndicator.toLowerCase()
            ) {
              if (
                this.indicators[i].value
                  .normalize('NFD')
                  .replace(/[\u0300-\u036f]/g, '')
                  .toLowerCase()
                  .includes(
                    item.indicatorValue
                      .normalize('NFD')
                      .replace(/[\u0300-\u036f]/g, '')
                      .toLowerCase(),
                  )
              ) {
                return true;
              }
              break;
            }
          }
        }
        return false;
      }
      return true;
    },
  },
  computed: {
    ...mapState('actions', ['testNpsReview']),
  },
  watch: {
    testNpsReview: function watchGrade(value) {
      this.replaceTagsOnText(this.researchInfo, value);
    },
  },
  async created() {
    this.apiRoot = process.env.API_ROOT;
    this.apiServerless = process.env.API_SERVERLESS;
    try {
      const params = this.$route.query;
      const id = params.id;
      this.isLinkChannel = this.$route.path.includes('/survey-totem/');
      this.indicators = [];
      if (!this.isLinkChannel) {
        if (id) {
          const responseIndicators = await api.get(
            `/qrcode-indicators/${this.$route.params.actionId}`,
            {
              params: { id },
            },
          );
          this.indicators = responseIndicators.data;
        } else {
          Object.keys(params).forEach((key) => {
            this.indicators.push({ column: key, value: params[key] });
          });
        }
      } else {
        Object.keys(params).forEach((key) => {
          if (key !== 'name' && key !== 'email' && key !== 'phone') {
            this.indicators.push({ column: key, value: params[key] });
          } else if (key === 'name') {
            this.dataContact.name = params[key];
          } else if (key === 'email') {
            this.dataContact.email = params[key];
          } else if (key === 'phone') {
            this.dataContact.phone = params[key];
          }
        });
      }
      const response = await api.get(
        `/qrcode-research-info/${this.$route.params.actionId}`,
        {
          params,
        },
      );

      this.researchInfo = response.data;
      if (this.researchInfo.action.questionStepByStep) {
        this.viewAll = false;
      } else {
        this.viewAll = true;
      }

      if (this.researchInfo.additionalQuestions.length) {
        const hasGrouped = this.researchInfo.additionalQuestions.filter(
          (item) => item.group >= 1,
        );

        if (hasGrouped.length) {
          const pages = [];
          this.researchInfo.additionalQuestions.forEach((a) => {
            if (!pages.find((item) => item.items.find((i) => i.id === a.id))) {
              pages.push({
                id: a.id,
                items: this.researchInfo.additionalQuestions.filter(
                  (item) => item.group === a.group,
                ),
              });
            }
          });

          this.pages = pages;
          this.isGrouped = true;
        }
      }
      const companyData = await api.get(
        `/surveys/companies/${this.researchInfo.action.companyId}`,
      );
      this.company = companyData.data;
      this.action = this.researchInfo.action;
      if (this.researchInfo.action.allAnswersAnonymous) {
        this.anonymousResponse = true;
      }
      if (this.researchInfo.enabledAudioResponse) {
        this.enabledAudioResponse = true;
      }
      this.replaceTagsOnText(this.researchInfo);
      this.setTestNpsReview(parseInt(this.$route.params.grade, 10));
      this.researchInfo.additionalQuestions.forEach((el) => {
        if (el.type === 'MULTIPLE') {
          el.addQuestionAnswerMultiple = {
            multipleValues: [],
            comment: null,
          };
        } else if (el.type === 'INPUT') {
          el.answerText = null;
        } else if (el.type === 'CONTACT') {
          if (el.displayType === 'afterSendAnswer') {
            this.typeModalContact = true;
          }
        } else {
          el.addQuestionAnswer = {
            review: null,
            comment: null,
          };
        }
      });
      if (this.researchInfo.metric.includes('0-10')) {
        this.promotersGrades = [10, 9];
        this.passivesGrades = [8, 7];
        this.detractorsGrades = [6, 5, 4, 3, 2, 1, 0];
      }

      if (this.researchInfo.metric === 'like-dislike') {
        this.promotersGrades = [1];
        this.detractorsGrades = [0];
      }

      const logoUrl = process.env.INDECX_FILES_BUCKET;
      this.logo = `${logoUrl}/${this.researchInfo.logo}`;

      this.loading = false;
    } catch (error) {
      this.loading = false;
      this.error = error.response.data.message;
    }
  },
  mounted() {
    this.loadDeviceUUID();
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
.loadingSubmit {
  position: fixed;
  z-index: 99999;
  height: 50%;
  width: 2em;
  overflow: visible;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  opacity: 1;
}

.sk-wave {
  width: 50px;
  height: 180px;
  text-align: center;
  font-size: 10px;
}

.closing-message-area {
  display: flex;
  flex-direction: column;
  i {
    font-size: 92px;
    color: #009bdb;
  }
  h4 {
    color: #009bdb;
  }
}
.error-area {
  display: flex;
  flex-direction: column;
  i {
    font-size: 92px;
    color: #009bdb;
  }
  h4 {
    color: #009bdb;
  }
}

.dark-mode {
  filter: brightness(50%);
}

.wrapp {
  position: relative;
  min-height: 100vh;
  max-height: 100vh;
  overflow: auto;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
  animation: appearsFromLeft 0.6s;
}
.addquestions-area {
  display: flex;
  flex-direction: column;
  animation: appearsFromLeft 0.6s;
}
.container {
  background-color: #fff;
}
.question {
  font-size: 1.1rem;
}
.required {
  color: red;
  font-size: 12px;
}
@keyframes appearsFromLeft {
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
</style>

<style>
.close-button {
  float: right;
  background-color: white;
  border: none;
}
.btn:focus {
  outline: none;
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/research-page-totem/index.vue